<template>
  <v-container fluid class="em-construcao-container">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <v-card class="em-construcao-card" elevation="8">
          <v-card-text class="text-center pa-8 pa-md-12">
            <!-- Ícone Animado -->
            <div class="icon-wrapper mb-6">
              <v-avatar color="#1d4ed8" size="140" class="icon-avatar elevation-8">
                <v-icon size="80" color="white" class="rotating-icon">mdi-cog</v-icon>
              </v-avatar>
              <v-icon class="tool-icon tool-1" color="#1d4ed8" size="32">mdi-wrench</v-icon>
              <v-icon class="tool-icon tool-2" color="#1d4ed8" size="28">mdi-hammer</v-icon>
            </div>
            
            <!-- Título -->
            <h1 class="display-1 font-weight-bold mb-3" style="color: #1d4ed8;">
              Em Construção
            </h1>
            
            <!-- Subtítulo -->
            <p class="text-h6 text--secondary mb-6 font-weight-light">
              Estamos trabalhando nesta funcionalidade
            </p>
            
            <!-- Botões de Ação -->
            <div class="d-flex flex-column flex-sm-row justify-center gap-3">
              <v-btn
                x-large
                color="#1d4ed8"
                dark
                @click="voltarInicio"
                elevation="4"
                min-width="200"
                class="btn-principal"
              >
                <v-icon left>mdi-home</v-icon>
                Voltar ao Início
              </v-btn>
              
              <v-btn
                x-large
                outlined
                color="#1d4ed8"
                @click="voltarAnterior"
                min-width="200"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Página Anterior
              </v-btn>
            </div>
            
            <!-- Informação Adicional -->
            <div class="mt-8 text-caption text--secondary">
              <v-icon x-small class="mr-1">mdi-information-outline</v-icon>
              Esta página estará disponível em breve para usuários autorizados
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'EmConstrucao',
  methods: {
    voltarInicio() {
      this.$router.push({ name: 'Monitor' })
    },
    voltarAnterior() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.em-construcao-container {
  min-height: calc(100vh - 64px);
  background: linear-gradient(135deg, #f5f7fa 0%, #e8edf2 100%);
  padding: 24px;
}

.fill-height {
  min-height: calc(100vh - 64px - 48px);
}

.em-construcao-card {
  border-radius: 20px !important;
  background: white;
  position: relative;
  overflow: visible;
}

.icon-wrapper {
  position: relative;
  display: inline-block;
}

.icon-avatar {
  position: relative;
  z-index: 2;
}

/* Ícone Rotativo */
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.rotating-icon {
  animation: rotate 8s linear infinite;
}

/* Ferramentas Flutuantes */
.tool-icon {
  position: absolute;
  animation: float 3s ease-in-out infinite;
}

.tool-1 {
  top: 10px;
  right: -10px;
  animation-delay: 0s;
}

.tool-2 {
  bottom: 20px;
  left: -10px;
  animation-delay: 1.5s;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
}

/* Botões */
.btn-principal {
  transition: all 0.3s ease;
}

.btn-principal:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(29, 78, 216, 0.3) !important;
}

.gap-3 {
  gap: 12px;
}

/* Responsividade */
@media (max-width: 600px) {
  .em-construcao-card {
    border-radius: 16px !important;
  }
  
  .icon-avatar {
    width: 100px !important;
    height: 100px !important;
  }
  
  .icon-avatar .v-icon {
    font-size: 60px !important;
  }
  
  .display-1 {
    font-size: 2rem !important;
  }
  
  .text-h6 {
    font-size: 1.1rem !important;
  }
}

/* Alert customizado */
.v-alert {
  border-radius: 12px !important;
}
</style>
